import React from 'react';
import { useNavigate } from 'react-router-dom';

const Svg = ({ type, size = 16 }) => {
  const icons = {
    check: <><polyline points="20,6 9,17 4,12"/></>,
    star: <><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></>,
    shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    music: <><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></>,
    radio: <><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.4"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.4"/><path d="M19.1 4.9C23 8.8 23 15.1 19.1 19"/><circle cx="12" cy="12" r="2"/></>,
    mic: <><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/></>,
    bar: <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>,
    arrow: <><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12,5 19,12 12,19"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>;
};

// Single canonical plan — $89 per location / month, unlimited zones (FPA/ROSCA-locked, 12 months).
const PLAN = {
  name: 'Groovie for Business',
  price: 89,
  subtitle: 'One price per location — unlimited zones',
  features: [
    'Your own branded radio station — unlimited channels per location',
    'Rights-controlled, Groovie-produced catalog',
    'AI announcements — type it, it airs',
    'Custom jingles & DJ shout-outs',
    'Calendar automation & scheduling',
    'Multi-location management — centralized control, per-location channels, and announcements to one location or all',
    'Analytics & branded QR codes',
    'Compliance dashboard',
    'Cancel anytime — effective at the end of your paid month',
  ],
};

export default function Pricing() {
  const navigate = useNavigate();
  var font = "'Outfit', 'DM Sans', -apple-system, sans-serif";

  return (
    <div style={{ minHeight: '100vh', background: '#fafafa', fontFamily: font }}>

      {/* Nav */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 40px', background: '#fff', borderBottom: '1px solid #e5e7eb',
        position: 'sticky', top: 0, zIndex: 50,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={function() { navigate('/'); }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
          }}>
            <Svg type="radio" size={18} />
          </div>
          <span style={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.5px', background: 'linear-gradient(to right, #22d3ee, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>groovie</span>
        </div>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <a href="/pricing" style={{ fontSize: 14, fontWeight: 600, color: '#7c3aed', textDecoration: 'none' }}>Pricing</a>
          <a href="/faq" style={{ fontSize: 14, fontWeight: 500, color: '#6b7280', textDecoration: 'none' }}>FAQ</a>
          <button onClick={function() { navigate('/login'); }} style={{
            padding: '8px 20px', borderRadius: 8, border: '1.5px solid #e5e7eb',
            background: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', color: '#374151', fontFamily: font,
          }}>Log In</button>
          <button onClick={function() { navigate('/register'); }} style={{
            padding: '8px 20px', borderRadius: 8, border: 'none',
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
            color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: font,
          }}>Start Free Trial</button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '60px 40px 20px', maxWidth: 760, margin: '0 auto' }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 16px',
          background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 20,
          fontSize: 13, fontWeight: 600, color: '#166534', marginBottom: 20,
        }}>
          <Svg type="shield" size={14} /> One price. Unlimited zones per location.
        </div>
        <h1 style={{ fontSize: 44, fontWeight: 800, color: '#111827', margin: '0 0 12px', letterSpacing: '-1.5px', lineHeight: 1.1 }}>
          One simple price<br />for your whole venue
        </h1>
        <p style={{ fontSize: 18, color: '#6b7280', margin: '0 0 8px', lineHeight: 1.6 }}>
          $89 per location, per month — with unlimited zones. No tiers, no add-ons.
        </p>
        <p style={{ fontSize: 14, color: '#9ca3af', margin: '0 0 32px', lineHeight: 1.6 }}>
          Groovie's rights-controlled, Groovie-produced catalog, cleared for distribution through Groovie.
        </p>
      </div>

      {/* Single Plan Card */}
      <div style={{ maxWidth: 440, margin: '0 auto', padding: '0 40px 40px' }}>
        <div style={{
          background: '#faf5ff', borderRadius: 20, padding: 36,
          border: '2px solid #7c3aed', display: 'flex', flexDirection: 'column',
          boxShadow: '0 12px 40px rgba(124,58,237,0.08)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <div style={{
              width: 40, height: 40, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: '#f5f3ff', color: '#7c3aed',
            }}>
              <Svg type="radio" size={20} />
            </div>
            <h3 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: 0 }}>{PLAN.name}</h3>
          </div>
          <p style={{ fontSize: 13, color: '#9ca3af', margin: '0 0 20px' }}>{PLAN.subtitle}</p>

          <div style={{ marginBottom: 4 }}>
            <span style={{ fontSize: 48, fontWeight: 800, color: '#111827', letterSpacing: '-2px' }}>${PLAN.price}</span>
            <span style={{ fontSize: 15, color: '#9ca3af' }}>/mo</span>
          </div>
          <p style={{ fontSize: 13, color: '#9ca3af', margin: '0 0 24px' }}>per location</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 28 }}>
            {PLAN.features.map(function(f) {
              return (
                <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: '#374151' }}>
                  <div style={{ color: '#7c3aed', flexShrink: 0 }}><Svg type="check" size={15} /></div>
                  <span>{f}</span>
                </div>
              );
            })}
          </div>

          <button onClick={function() { navigate('/register'); }} style={{
            width: '100%', padding: '14px', borderRadius: 12, border: 'none',
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
            color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: font,
            boxShadow: '0 4px 16px rgba(124,58,237,0.28)',
          }}>
            Start Free Trial <span style={{ marginLeft: 4 }}>{'→'}</span>
          </button>
          <p style={{ fontSize: 12, color: '#9ca3af', textAlign: 'center', margin: '12px 0 0' }}>
            21-day free trial. No credit card required.
          </p>
        </div>
      </div>

      {/* What's included */}
      <div style={{ background: '#fff', padding: '60px 40px', borderTop: '1px solid #e5e7eb' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, color: '#111827', margin: '0 0 8px' }}>Everything in one subscription</h2>
          <p style={{ fontSize: 15, color: '#9ca3af', margin: '0 0 40px' }}>Your branded, always-on station — set up in minutes</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
            {[
              { icon: 'shield', title: 'Rights-controlled catalog', desc: "Groovie's rights-controlled, Groovie-produced catalog, cleared for distribution through Groovie. Your subscription covers Groovie-supplied programming only — not music you supply or play separately." },
              { icon: 'music', title: 'Curated music', desc: 'Genre playlists and mood stations across your zones, refreshed automatically.' },
              { icon: 'mic', title: 'AI announcements', desc: 'Announcements in a virtual station-host voice, scheduled or on demand.' },
              { icon: 'bar', title: 'Real-time analytics', desc: 'Listener counts, peak hours, and popular stations across your locations.' },
              { icon: 'radio', title: 'Autonomous broadcasting', desc: 'Calendar automation and smart rotation — set it and it runs.' },
              { icon: 'star', title: 'Compliance dashboard', desc: 'Your programming provenance and device status in one place.' },
            ].map(function(item) {
              return (
                <div key={item.title} style={{ padding: 24, borderRadius: 16, background: '#fafafa', border: '1px solid #f3f4f6', textAlign: 'left' }}>
                  <div style={{
                    width: 44, height: 44, borderRadius: 12, marginBottom: 14,
                    background: '#f5f3ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#7c3aed',
                  }}>
                    <Svg type={item.icon} size={20} />
                  </div>
                  <h4 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: '0 0 6px' }}>{item.title}</h4>
                  <p style={{ fontSize: 13, color: '#6b7280', margin: 0, lineHeight: 1.5 }}>{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center', padding: '60px 40px', background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)' }}>
        <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', margin: '0 0 12px', letterSpacing: '-0.5px' }}>Ready to give your venue its own station?</h2>
        <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.8)', margin: '0 0 28px' }}>Start your free trial. No credit card required.</p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          <button onClick={function() { navigate('/register'); }} style={{
            padding: '14px 32px', borderRadius: 12, border: 'none',
            background: '#fff', color: '#7c3aed', fontSize: 16, fontWeight: 700,
            cursor: 'pointer', fontFamily: font, boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          }}>Start Free Trial</button>
          <button onClick={function() { navigate('/faq'); }} style={{
            padding: '14px 32px', borderRadius: 12, border: '2px solid rgba(255,255,255,0.3)',
            background: 'transparent', color: '#fff', fontSize: 16, fontWeight: 600,
            cursor: 'pointer', fontFamily: font,
          }}>View FAQ</button>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ padding: '24px 40px', background: '#111827', textAlign: 'center' }}>
        <p style={{ fontSize: 13, color: '#9ca3af', margin: 0 }}>{'©'} {new Date().getFullYear()} Gooverio Labs LLC. All rights reserved. Groovie is a trademark of Gooverio Labs LLC.</p>
      </footer>
    </div>
  );
}
